module.exports = __webpack_public_path__ + "static/img/20200518-02.5b8c0ce.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/20200518-02.png
// module id = bIC/
// module chunks = 1